<template>
  <div
    v-if="spinner || retry"
    class="parts-generate-status d-flex justify-center"
  >
    <div class="article-content parts-generate-status__shell">
      <v-progress-linear
        v-if="spinner"
        indeterminate
        color="accent"
        height="4"
        class="parts-generate-spinner"
      />
      <v-alert
        v-else-if="retry"
        type="error"
        colored-border
        border="left"
        class="parts-generate-retry-alert"
      >
        <div class="font-weight-bold mb-1">{{ $t(copyKey + '.title') }}</div>
        <div class="body-2 mb-3">{{ $t(copyKey + '.content') }}</div>
        <v-btn
          depressed
          color="accent"
          class="text-none parts-generate-retry"
          @click="$emit('retry')"
        >
          {{ $t(copyKey + '.retry') }}
        </v-btn>
      </v-alert>
    </div>
  </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import {partsRetryVisible, partsSpinnerOn} from '@/service/partsTerminalState';

    export default Vue.extend({
        name: 'PartsGenerateStatus',
        props: {
            enhanced: {
                type: String,
                default: null,
            },
            aiGenerateStatus: {
                type: String,
                default: null,
            },
            /** whole = a new article written in one piece; parts = URL-improve. */
            mode: {
                type: String,
                default: 'parts',
            },
        },
        computed: {
            copyKey(): string {
                return this.mode === 'whole' ? 'article.wholeFailed' : 'article.partsFailed';
            },
            spinner(): boolean {
                return partsSpinnerOn(this.enhanced);
            },
            retry(): boolean {
                return partsRetryVisible({
                    enhanced: this.enhanced,
                    aiGenerateStatus: this.aiGenerateStatus,
                });
            },
        },
    });
</script>

<style scoped lang="sass">
.parts-generate-status__shell
    padding-top: 12px
    padding-bottom: 16px
    position: relative
    z-index: 0

.parts-generate-spinner
    pointer-events: none

.parts-generate-retry-alert
    margin-bottom: 0 !important
</style>
